var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceivingWorkspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7499_15467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7499_15467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49971 15.7585C6.30992 15.7585 6.15083 15.6942 6.02244 15.5658C5.89404 15.4375 5.82983 15.2784 5.82983 15.0886V9.71678C5.82983 9.56333 5.88135 9.43469 5.9844 9.33087C6.08742 9.22705 6.21509 9.17514 6.3674 9.17514C6.5197 9.17514 6.64874 9.22705 6.7545 9.33087C6.86026 9.43469 6.91315 9.56333 6.91315 9.71678V13.9011L14.8458 5.96843C14.9612 5.85304 15.0889 5.79401 15.2288 5.79135C15.3688 5.78868 15.4991 5.84771 15.6199 5.96843C15.7406 6.08915 15.8009 6.21815 15.8009 6.35543C15.8009 6.49272 15.7406 6.62173 15.6199 6.74245L7.68717 14.6751H11.8715C12.025 14.6751 12.1536 14.7267 12.2574 14.8297C12.3612 14.9327 12.4131 15.0604 12.4131 15.2127C12.4131 15.365 12.3612 15.494 12.2574 15.5998C12.1536 15.7056 12.025 15.7585 11.8715 15.7585H6.49971Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivingWorkspace);
export default __webpack_public_path__ + "static/media/receiving-workspace.f42f87fa17e29ff34289b0d01550b365.svg";
export { ForwardRef as ReactComponent };